/**
 * 功能开关
 * 2026-08-26: 初一3班上线，测评功能暂不开放
 */
export const FEATURE_FLAGS = {
  /** 测评功能（自适应测评 + 教师发布测评任务） */
  ENABLE_ASSESSMENT: false,
};
